import { Tooltip, TooltipProps } from "@mui/material";
import { Row } from "../../misc/Row";

export function EventInfoRow(
  props: React.PropsWithChildren<{
    tooltip?: React.ReactNode;
    tooltipPlacement?: TooltipProps["placement"];
    isHighlighted?: boolean;
    highlightColor?: "eventChangeBefore.main" | "eventChangeAfter.main";
  }>,
) {
  const { tooltip, tooltipPlacement, isHighlighted, highlightColor, children } = props;
  return (
    <Tooltip title={tooltip} arrow placement={tooltipPlacement ?? "left"}>
      {/* The <div> below is needed, so that the tooltip actually pops up on mouse over,
          see https://mui.com/material-ui/react-tooltip/#custom-child-element */}
      <div>
        <Row
          spacing="0.5em"
          alignItems="center"
          color={isHighlighted ? "common.white" : undefined}
          sx={
            isHighlighted
              ? {
                  bgcolor: highlightColor,
                  borderRadius: "4px",
                  px: 0.5,
                  py: 0.25,
                  width: "fit-content",
                  "& a": { color: "inherit", textDecoration: "none" },
                  "& .MuiSvgIcon-root": { color: "common.white", fontSize: "16px" },
                }
              : undefined
          }
        >
          {children}
        </Row>
      </div>
    </Tooltip>
  );
}
